// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2A6QT","imageUploader":"EGiftCard_imageUploader__2taXF"};